import React, { useCallback, useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { useDropzone } from "react-dropzone";
import "./flightdata-dropzone.scss";
import { Toast } from "primereact/toast";
import {
  getToastSuccess,
  getToastError,
} from "../../../redux/actions/toastActions";
import LoadingIndicator from "../../LoadingIndicator";
import { t } from "i18next";
import "../../../services/scheduleService";
import docIcon from "../../../assets/images/docIcon.svg";
import deleteIcon from "../../../assets/images/delete.svg";
import uploadIconBlack from "../../../assets/images/uploadIconBlack.svg";

const FlightDataDropzone = ({
  setDisplayUploadSection,
  setFileData,
  file,
  setFile,
}) => {
  const [isLoading, setLoading] = useState(false);

  const onDrop = useCallback((acceptedFiles) => {
    setLoading(true);
    if (acceptedFiles && acceptedFiles.length) {
      acceptedFiles.forEach((file) => {
        const filepathArray = file.path.split(".");
        if (
          filepathArray[filepathArray.length - 1] !== "xlsx" &&
          filepathArray[filepathArray.length - 1] !== "xlx"
        ) {
          setFile(null);
          return;
        }
        setFile(file);
        const reader = new FileReader();
        reader.onabort = () => console.log("file reading was aborted");
        reader.onerror = () => console.log("file reading has failed");
        reader.onload = () => {
          
          const binaryStr = reader.result;
        };
        reader.readAsArrayBuffer(file);
        handleUploadFile(file);
      });
    }
  }, []);


  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });


  const handleUploadFile = (props) => {
    setDisplayUploadSection(false);
    setFileData(props);
    setLoading(false);
  };

  const handleDelete = () => {
    setFile(null);
    setFileData(null);
  };

  return (
    <>
      {isLoading ? <LoadingIndicator /> : ""}
      <div className="dg-upload-body w-100">
        {file ? (
          <div className="file-details-panel">
            <div className="details-left">
              <img src={docIcon} alt="Document Icon" />
              <div className="file-details">
                <label className="name-label">{file.name}</label>
                <label className="size-label">
                  {(file.size / 1024).toFixed(2)} KB
                </label>
              </div>
            </div>
            <img
              src={deleteIcon}
              alt="Delete"
              className="delete-icon"
              onClick={handleDelete}
            />
          </div>
        ) : (
          <div className="file-upload-block">
            <div className="upload-content-block" {...getRootProps()}>
              <input {...getInputProps()} />
              <img
                src={uploadIconBlack}
                alt="upload"
                title="upload"
                id="upload-icon"
              />
              <div className="upload-drop-label">
                <label className="upload-label" >
                  {t("COMMON.UPLOAD_CLICK")}
                </label>
                <label className="drop-label">{t("COMMON.UPLOAD_DROP")}</label>
              </div>
              <label className="drop-label">
                {t("COMMON.UPLOAD_XLS_INFO")}
              </label>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({ loader, toast }) => ({
  toastDetails: toast.toastDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getToastSuccess: (message) => {
    dispatch(getToastSuccess(message));
  },
  getToastError: (message) => {
    dispatch(getToastError(message));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(FlightDataDropzone);
